import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import { debounce } from 'lodash-es';

export default function getRouting() {
    const pushToGtm = debounce((url) => {
        if ('dl' in window) {
            window.dl.push({
                event: 'search',
                parameters: url,
            });
        }
    }, 1000);

    const routing = {
        router: historyRouter(),
        stateMapping: {
            stateToRoute({ query, menu, page, range }) {
                return {
                    query,
                    page,
                    category: menu && menu['roam_products_categories.lvl0'],
                    region: menu && menu['roam_products_regions.lvl0'],
                    dates: range && range.roam_products_eventDates,
                };
            },
            routeToState({ query, category, region, page, dates }) {
                return {
                    query,
                    page,
                    menu: {
                        'roam_products_categories.lvl0': category,
                        'roam_products_regions.lvl0': region,
                    },
                    range: {
                        roam_products_eventDates: dates,
                    },
                };
            },
        },
    };

    const originalWrite = routing.router.write.bind(routing.router);
    routing.router.write = (routeState) => {
        originalWrite(routeState);
        pushToGtm(routing.router.createURL(routeState));
    };

    return routing;
}
